import HoverSortCommonSimple from '@/pages/opinion/components/HoverSortCommonSimple';
import React, { useState } from 'react';
import { List } from 'tea-component';
import { useIntl } from 'umi';
import BubbleCommon, { commonValidationTips } from '../../../BubbleCommon';
import { SortBy } from 'tea-component/lib/table/addons';

export default function ValidationHeader({
  sort,
  setSort,
  excludeInvalidInfo,
}: {
  sort: SortBy<any>;
  setSort: (sort: SortBy<any>) => void;
  excludeInvalidInfo?: [boolean, (isExcludeInvalid: boolean) => void];
}) {
  const { formatMessage } = useIntl();
  const [isExcludeInvalid, setIsExcludeInvalid] =
    excludeInvalidInfo || useState(false);

  const onChange = () => {
    setIsExcludeInvalid(!isExcludeInvalid);
  };

  return (
    <HoverSortCommonSimple
      sortKey="sort_isvalid"
      sort={sort}
      titleLeft
      isActive={isExcludeInvalid}
      sortChange={(sortItem: any) => setSort(sortItem)}
      dropdownProps={{
        footer:
          isExcludeInvalid === undefined ? null : (
            <List type="option">
              <List.Item onClick={onChange} selected={isExcludeInvalid}>
                {formatMessage({ id: 'Exclude Invalid' })}
              </List.Item>
            </List>
          ),
      }}
    >
      <>
        {formatMessage({ id: 'Validation' })}
        <BubbleCommon
          placement="top"
          tipsMap={commonValidationTips}
        ></BubbleCommon>
      </>
    </HoverSortCommonSimple>
  );
}

export function ValidationHeaderNew({
  sort,
  setSort,
  options,
  selectValue,
  onChange,
}: {
  sort: { by: string; order: 'asc' | 'desc' };
  setSort: (sortItem?: { by: string; order: 'asc' | 'desc' }) => void;
  options: Array<{ text: string; value: string }>;
  selectValue?: string;
  onChange: (value?: string) => void;
}) {
  const { formatMessage } = useIntl();

  const onChangeOptions = (value: string) => {
    if (value === selectValue) {
      onChange(undefined);
    } else {
      onChange(value);
    }
  };

  return (
    <HoverSortCommonSimple
      sortKey="sort_isvalid"
      sort={sort}
      titleLeft
      isActive={!!selectValue}
      sortChange={(sortItem) => {
        setSort(sortItem);
      }}
      dropdownProps={{
        footer: (
          <List type="option">
            {options.map((item) => {
              return (
                <List.Item
                  key={item.value}
                  onClick={() => onChangeOptions(item.value)}
                  selected={selectValue === item.value}
                >
                  {formatMessage({ id: item.text })}
                </List.Item>
              );
            })}
          </List>
        ),
      }}
    >
      {formatMessage({ id: 'Validation' })}
    </HoverSortCommonSimple>
  );
}
